/**
 * REACT ROUTER CONFIGURATION - MAIN APP ONLY
 * 
 * This file contains the React Router v6 configuration for the NLFB Main Application.
 * It supports environment-specific base paths:
 * - Development: / (root)
 * - Staging: /foodbarn/frontend
 * - Production: / (root)
 * 
 * IMPORTANT: This is the MAIN APP router only. Admin routes are in the separate admin app.
 */

import { createBrowserRouter } from 'react-router-dom';
import { MainLayout } from '@/layouts/MainLayout';

// Page imports - ONLY main site components
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import { CategoryDetail } from '@/pages/CategoryDetail';
import FoodParcelsPage from '@/pages/FoodParcelsPage';
import VolunteerPage from '@/pages/VolunteerPage';
import ContactPage from '@/pages/ContactPage';
import TermsPage from '@/pages/TermsPage';
import SponsorsPage from '@/pages/SponsorsPage';
import DonationsPage from '@/pages/DonationsPage';
import CommunityCarePage from '@/pages/CommunityCarePage';
import OrderPage from '@/pages/OrderPage';
import OrderHistoryPage from '@/pages/OrderHistoryPage';
import PaymentConfirmationPage from '@/pages/PaymentConfirmationPage';
import VolunteerApplicationPage from '@/pages/VolunteerApplicationPage';
import DeliveryFeesPage from '@/pages/DeliveryFeesPage';
import ColorPaletteTestPage from '@/pages/ColorPaletteTestPage';

// Create router with environment-specific basename
const createMainAppRouter = () => {
  // Use Vite's BASE_URL (from vite.config base) so router matches the actual deploy path.
  const baseUrl = import.meta.env.BASE_URL ?? '/';
  const basename = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

  return createBrowserRouter([
    // Main site routes with MainLayout
    {
      path: '/',
      element: <MainLayout />,
      children: [
        {
          index: true,
          element: <HomePage />
        },
        {
          path: 'about',
          element: <AboutPage />
        },
        {
          path: 'category/:id',
          element: <CategoryDetail />
        },
        {
          path: 'food-parcels',
          element: <FoodParcelsPage />
        },
        {
          path: 'volunteer',
          element: <VolunteerPage />
        },
        {
          path: 'volunteer/apply',
          element: <VolunteerApplicationPage />
        },
        {
          path: 'contact',
          element: <ContactPage />
        },
        {
          path: 'terms',
          element: <TermsPage />
        },
        {
          path: 'sponsors',
          element: <SponsorsPage />
        },
        {
          path: 'donations',
          element: <DonationsPage />
        },
        {
          path: 'community-care',
          element: <CommunityCarePage />
        },
        {
          path: 'order',
          element: <OrderPage />
        },
        {
          path: 'order-history',
          element: <OrderHistoryPage />
        },
        {
          path: 'payment-confirmation',
          element: <PaymentConfirmationPage />
        },
        {
          path: 'delivery-fees',
          element: <DeliveryFeesPage />
        },
        {
          path: 'color-palette-test',
          element: <ColorPaletteTestPage />
        }
      ]
    }
  ], {
    basename: basename
  });
};

// Export the router creation function
export default createMainAppRouter; 